import { useCallback, useContext } from 'react';

import FileDownloadResultContext from '~contexts/FileDownloadResultContext';
import { useStores } from '~store';
import { alert, AlertTypes } from '~types/AlertTypes';

import { getPdfRenderValidationMessage } from './models';

interface RenderedPdfResponse {
  data: { data: { ids: string[] } };
}

interface DownloadRenderedPdfParams {
  failureMessage: string;
  render: () => Promise<RenderedPdfResponse>;
  timeoutMs?: number;
}

export default function useRenderedPdfDownload() {
  const { toasterStore } = useStores();
  const { enqueueFileDownload } = useContext(FileDownloadResultContext);

  const downloadRenderedPdf = useCallback(
    async ({ failureMessage, render, timeoutMs }: DownloadRenderedPdfParams) => {
      try {
        const response = await render();
        const renderId = response.data.data.ids[0];

        if (!renderId) {
          toasterStore.push(alert(failureMessage, AlertTypes.error));

          return;
        }

        if (timeoutMs) {
          enqueueFileDownload(renderId, { timeoutMs });
        } else {
          enqueueFileDownload(renderId);
        }
      } catch (error) {
        const validationMessage = getPdfRenderValidationMessage(error);

        if (validationMessage) {
          toasterStore.push(alert(validationMessage, AlertTypes.info));

          return;
        }

        toasterStore.push(alert(failureMessage, AlertTypes.error));
      }
    },
    [enqueueFileDownload, toasterStore],
  );

  return { downloadRenderedPdf };
}
